module.exports = __webpack_public_path__ + "img/headphones.b71dcb00.svg";